import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PackagesPersoService } from 'src/services/packages-perso.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isDemoLimitErrorCode } from 'src/enum/codeErreur';

@Component({
    selector: 'app-confirmation-toggle-package-dialog',
    templateUrl: './confirmation-toggle-package-dialog.component.html',
    styleUrls: ['./confirmation-toggle-package-dialog.component.scss'],
    imports: [
        MatDialogModule,
        TranslateModule
    ]
})
export class ConfirmationTogglePackageDialogComponent {
  packageName: string;
  isActivating: boolean;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationTogglePackageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      packageId: number; 
      packageName: string; 
      currentStatus: boolean; 
    },
    private packagesPersoService: PackagesPersoService,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    this.packageName = data.packageName;
    this.isActivating = !data.currentStatus; // Si actuellement désactivé, on active
  }

  onConfirm(): void {
    this.packagesPersoService.togglePackageActivation(this.data.packageId, this.isActivating)
      .subscribe({
        next: () => {
          const messageKey = this.isActivating ? 
            'PACKAGES_PERSO_MANAGEMENT.ACTIVATION_SUCCESS' : 
            'PACKAGES_PERSO_MANAGEMENT.DEACTIVATION_SUCCESS';
          
          this.translate.get(messageKey).subscribe(message => {
            this.snackBar.open(message, 'OK', { duration: 3000 });
          });
          this.dialogRef.close(true);
        },
        error: (err) => {
          if (err?.status === 422 && isDemoLimitErrorCode(err.error?.codeErreur)) {
            this.dialogRef.close(false);

            return;
          }

          let messageKey: string;

          if (this.isActivating && err?.status === 400) {
            const messageServeur: string = typeof err.error === 'string' ? err.error.trim() : '';

            if (messageServeur !== '') {
              this.snackBar.open(messageServeur, 'OK', { duration: 5000 });
              this.dialogRef.close(false);

              return;
            }

            messageKey = 'PACKAGES_PERSO_MANAGEMENT.ACTIVATION_VIDEO_NOT_READY';
          } else {
            messageKey = this.isActivating ?
              'PACKAGES_PERSO_MANAGEMENT.ACTIVATION_ERROR' :
              'PACKAGES_PERSO_MANAGEMENT.DEACTIVATION_ERROR';
          }

          this.translate.get(messageKey).subscribe(message => {
            this.snackBar.open(message, 'OK', { duration: 5000 });
          });
          this.dialogRef.close(false);
        }
      });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}